module.exports = __webpack_public_path__ + "static/media/iphone11right.d0ed0047.png";